/**
 * card-print 共通カラー入力。
 *
 * 以前はインラインのスウォッチ列 + ネイティブ `<input type=color>` だったが、
 * クリックで OS の「色の選択」ダイアログ (Windows の古いパレット) が開いてしまうため、
 * masters の {@link ColorSwatch} ポップオーバー (モダンな 20 色パレット + 任意色ピッカー内蔵) に統一した。
 *
 * 本コンポーネントは ColorSwatch の薄いラッパー。card-print 側の API
 * (`value: string` 固定 / `onChange: (string) => void` / `size: 'sm' | 'md'`) を保ち、
 * 既存呼び出し側 (ThemeEditor / FieldsEditor) を変えずにポップオーバー UI へ移行する。
 *
 * - 継承 (クリア) 概念は card-print のテーマ/書式色には無いため `showClear={false}`。
 * - 値は常に hex string (例 '#2563eb')。ポップオーバー内のパレット or 任意色ピッカーで変更する。
 */
import { ColorSwatch, SWATCH_PALETTE } from '../masters';

/** モダンなスウォッチパレット (ColorSwatch と共有、後方互換のため再エクスポート)。 */
export const COLOR_SWATCHES: readonly string[] = SWATCH_PALETTE;

export interface ColorInputProps {
  /** 現在の色 (hex string、例 '#2563eb')。 */
  value: string;
  /** 色が選ばれたときに呼ばれる (string)。 */
  onChange: (next: string) => void;
  disabled?: boolean;
  /** スクリーンリーダー / テスト用ラベル。 */
  ariaLabel?: string;
  /** スウォッチの大きさ調整 (既定 'md')。 */
  size?: 'sm' | 'md';
}

export function ColorInput({
  value,
  onChange,
  disabled,
  ariaLabel,
  size = 'md',
}: ColorInputProps): JSX.Element {
  return (
    <span data-testid="color-input">
      <ColorSwatch
        value={value || undefined}
        onChange={(next) => {
          // showClear={false} なので undefined は来ない想定だが念のためガード。
          if (next) onChange(next);
        }}
        disabled={disabled}
        showClear={false}
        size={size === 'sm' ? 22 : 28}
        ariaLabel={ariaLabel}
      />
    </span>
  );
}
